var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "902px",
    height: "902px",
    viewBox: "0 0 902 902",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CartBack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CartBack",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Cart",
    fill: "#AEABD1",
    points: "5.05915036 230.353 69.3061504 265.275 194.29915 209.354 116.21015 172.067 5.05915036 230.353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17915,4.79 C181.43915,1.223 175.76615,-0.913 171.93015,0.928 L136.83415,17.77 C134.00815,19.127 131.99815,22.14 132.10915,24.851 L132.39215,31.68 L179.82315,8.917 C181.62915,8.049 182.52915,6.473 182.17915,4.79",
    id: "Fill-127",
    fill: "#223A6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.81915,99.14 L137.70915,76.628 C137.26315,76.431 136.74215,76.634 136.54615,77.08 C136.34915,77.526 136.55215,78.047 136.99815,78.243 L188.10915,100.756 C188.55915,100.952 189.07915,100.75 189.26915,100.304 C189.46915,99.858 189.26915,99.337 188.81915,99.14",
    id: "Fill-129",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.56315,72.491 L188.09915,94.696 C188.54915,94.895 189.06915,94.696 189.26915,94.252 C189.46915,93.807 189.26915,93.284 188.82915,93.085 L139.28515,70.88 C138.84015,70.681 138.31815,70.88 138.11815,71.324 C137.91915,71.769 138.11815,72.292 138.56315,72.491",
    id: "Fill-130",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.90215,56.298 L141.007155,32.474 C141.00815,32.179 140.86015,31.901 140.61515,31.737 C140.37015,31.573 140.05715,31.542 139.78415,31.656 L133.25015,34.38 C132.92815,34.514 132.71615,34.824 132.70715,35.172 L131.98015,64.301 C131.96815,64.788 132.35315,65.193 132.84015,65.2062731 C133.32815,65.218 133.73315,64.833 133.74515,64.345 L134.45815,35.789 L139.23615,33.797 L139.13715,56.29 C139.13515,56.778 139.52815,57.174 140.01615,57.177 C140.50315,57.179 140.90015,56.785 140.90215,56.298",
    id: "Fill-133",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5901504,141.038 L0.920150357,172.793 C0.532150357,173.088 0.458150357,173.642 0.753150357,174.03 C1.04815036,174.418 1.60215036,174.493 1.99015036,174.197 L43.6601504,142.442 C44.0471504,142.147 44.1221504,141.593 43.8271504,141.205 C43.5311504,140.817 42.9771504,140.743 42.5901504,141.038",
    id: "Fill-150",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4931504,182.364 L42.5191504,164.683 C42.9121504,164.395 42.9961504,163.842 42.7071504,163.449 C42.4181504,163.057 41.8661504,162.973 41.4731504,163.262 L17.4471504,180.942 C17.0541504,181.231 16.9701504,181.784 17.2591504,182.176 C17.5481504,182.569 18.1011504,182.653 18.4931504,182.364",
    id: "Fill-164",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.70215,100.978 L132.16015,90.339 C132.55315,90.05 132.63715,89.497 132.34815,89.105 C132.05915,88.712 131.50615,88.628 131.11415,88.917 L116.65615,99.557 C116.26315,99.846 116.17915,100.398 116.46815,100.791 C116.75715,101.183 117.30915,101.267 117.70215,100.978",
    id: "Fill-165",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.24615,94.238 L128.95715,70.116 C129.33115,69.803 129.37915,69.246 129.06515,68.873 C128.75215,68.499 128.19515,68.451 127.82215,68.765 L99.1111504,92.887 C98.7381504,93.2 98.6891504,93.757 99.0031504,94.13 C99.3171504,94.503 99.8731504,94.552 100.24615,94.238",
    id: "Fill-166",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.98015,76.015 L131.98015,101.739 C131.98015,102.227 132.37515,102.622 132.86215,102.622 C133.35015,102.622 133.74515,102.227 133.74515,101.739 L133.74515,76.015 C133.74515,75.527 133.35015,75.132 132.86215,75.132 C132.37515,75.132 131.98015,75.527 131.98015,76.015",
    id: "Fill-167",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9501504,151.729 L30.4481504,180.676 C30.4731504,181.163 30.8881504,181.537 31.3751504,181.512 C31.8621504,181.487 32.2361504,181.072 32.2111504,180.585 L30.7131504,151.638 C30.6881504,151.151 30.2731504,150.777 29.7861504,150.802 C29.2991504,150.827 28.9251504,151.242 28.9501504,151.729",
    id: "Fill-169",
    fill: "#27427A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartBack);
export default __webpack_public_path__ + "static/media/CartBack.7837587ab5e87c1927da36e27b52399f.svg";
export { ForwardRef as ReactComponent };